import { compareAppVersion } from './utils';

function isIOS(): boolean {
  // eslint-disable-next-line @typescript-eslint/prefer-ts-expect-error
  // @ts-ignore
  const { os } = lynx.__globalProps;
  return os === 'ios' || os === 'iOS';
}

const appVersion = (): string | undefined =>
  // eslint-disable-next-line @typescript-eslint/prefer-ts-expect-error
  // @ts-ignore
  lynx.__globalProps.appVersion ?? lynx.__globalProps.app_version;
const AstroJSBLowVersion = {
  ios: '25.7.0',
  andriod: '26.8.4',
};

export const getSlardarTraceparentLynx = (): Promise<string> =>
  new Promise((resolve, reject) => {
    try {
      const isIOSAPP = isIOS();
      const appVersionStr = appVersion() || '0';

      if (
        (!isIOSAPP &&
          compareAppVersion(appVersionStr, AstroJSBLowVersion.andriod) >= 0) ||
        (isIOSAPP &&
          compareAppVersion(appVersionStr, AstroJSBLowVersion.andriod) >= 0)
      ) {
        // eslint-disable-next-line @typescript-eslint/prefer-ts-expect-error
        // @ts-ignore
        NativeModules.bridge.call(
          'ec_get_traceparent',
          {
            protocolVersion: '1.0.0',
            data: {},
          },

          (res: any) => {
            if (res?.code === 1) {
              const traceparent = res?.data?.network_traceparent;
              // eslint-disable-next-line no-console
              console.log('traceparent', traceparent);
              resolve(traceparent);
              return;
            }
            resolve('');
          },
        );
      }
    } catch (e) {
      reject(e);
    }
  });
